import { render, staticRenderFns } from "./FlipVIcon.vue?vue&type=template&id=dbdbddd2&"
import script from "./FlipVIcon.vue?vue&type=script&lang=js&"
export * from "./FlipVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports